import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768;

export const isMobile = () => {
    return window.innerWidth <= MOBILE_BREAKPOINT;
};

export const useIsMobile = () => {
    const [isMobileView, setIsMobileView] = useState(isMobile());

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(isMobile());
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobileView;
};

export const mobileCss = (styles: string) => `
    @media (max-width: ${MOBILE_BREAKPOINT}px) {
        ${styles}
    }
`;
